import script from "./SettingsTerminalsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsTerminalsSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsTerminalsSection.vue?vue&type=style&index=0&id=6a46ff2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a46ff2a"]])

export default __exports__